import React from 'react'
import cx from 'classnames'

import { FormFieldLabel } from 'components/shared/FormFieldLabel/FormFieldLabel'
import { FormFieldMessage } from 'components/shared/FormFieldMessage/FormFieldMessage'
import { FormFields } from 'components/shared/FormFields/FormFields'

import {
  CHECKBOX_FIELD,
  RADIO_FIELD,
  EDITOR_FIELD,
  SCORE_FIELD,
  SWITCH_FIELD,
} from 'components/shared/FormFields/model'

import type { FormFieldProps } from 'components/shared/FormFields/types'
import styles from './Field.module.scss'

export const Field = ({
  accept,
  className,
  control,
  count,
  error,
  field,
  fieldClassName,
  hint,
  hintVariant,
  id,
  label,
  labelClassName,
  labelSize,
  labels,
  limit,
  max,
  min,
  multiple,
  name,
  options,
  placeholder,
  score,
  step,
  type,
  noOptionsMessage,
  transformData,
  variables,
  fetchOptions,
  closeMenuOnSelect,
  isClearable,
  isCreatable,
  isDisabled,
  isMulti,
  isOptional,
  isReadOnly,
  isRequired,
  isScoreActive,
  isSearchable,
}: FormFieldProps) => {
  const horizontalFields: (string | undefined)[] = [
    CHECKBOX_FIELD,
    RADIO_FIELD,
    SWITCH_FIELD,
  ]
  const isHorizontalOrientation = horizontalFields.includes(field)
  const isCheckbox = field === CHECKBOX_FIELD
  const isRadio = field === RADIO_FIELD
  const isEditor = field === EDITOR_FIELD
  const isScore = field === SCORE_FIELD
  const isSwitch = field === SWITCH_FIELD

  return (
    <div
      className={cx(
        styles.field,
        {
          [styles.horizontal]: isHorizontalOrientation,
          [styles.checkbox]: isCheckbox,
          [styles.radio]: isRadio,
          [styles.switch]: isSwitch,
        },
        className,
      )}
    >
      {Boolean(label) ? (
        <FormFieldLabel
          className={labelClassName}
          size={labelSize}
          {...{
            id,
            label,
            name,
            isCheckbox,
            isDisabled,
            isEditor,
            isHorizontalOrientation,
            isOptional,
            isScore,
            isScoreActive,
            isSwitch,
          }}
        />
      ) : null}
      <FormFields
        {...{
          accept,
          control,
          error,
          field,
          fieldClassName,
          noOptionsMessage,
          hint,
          id,
          labels,
          max,
          min,
          multiple,
          name,
          options,
          placeholder,
          score,
          step,
          type,
          variables,
          fetchOptions,
          closeMenuOnSelect,
          transformData,
          isClearable,
          isCreatable,
          isDisabled,
          isMulti,
          isReadOnly,
          isRequired,
          isSearchable,
        }}
      />
      <FormFieldMessage {...{ count, error, hint, hintVariant, limit }} />
    </div>
  )
}
